import { motion } from "framer-motion";
import React from "react";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { isMobile } from "react-device-detect";
import { useSelector } from "react-redux";
import MidBox from "../../components/Boxes/MidBox";
import Button from "../../components/Button";
import useToast from "../../hooks/useToast";
import { useAppTranslation } from "../../i18n/useAppTranslation";

const WalletAddressBox = () => {
  const userInfo = useSelector((state: any) => state.userInfo);

  const openToast = useToast();
  const { t } = useAppTranslation(["profile", "common"]);

  return (
    <motion.div
      initial={isMobile ? undefined : { opacity: 0, y: 200 }}
      transition={{
        duration: 0.3,
        delay: 0,
      }}
      animate={{
        opacity: 1,
        y: 0,
      }}
      exit={{ opacity: 0, y: -200 }}
      className="col-12 mb-2 "
    >
      <MidBox modal title={t("profile:walletAddressBox.title")}>
        <div className="d-flex flex-wrap px-4 px-md-3">
          <div className="col-12 col-md-7 col-lg-10 mb-3 mb-md-0">
            <label
              htmlFor="basic-url"
              className="form-label text-light fs-small fw-bold text-shadow mb-1"
            >
              {t("profile:walletAddressBox.yourWalletAddress")}
            </label>
            <br />
            <input
              readOnly
              value={userInfo?.walletAddress}
              className="fs-med fw-med dark-yellow text-wrap-force transparent-input w-100"
            />
          </div>
          <div className="col-12 col-md-3 col-lg-2 text-center text-md-end">
            <CopyToClipboard
              text={userInfo?.walletAddress}
              onCopy={() =>
                openToast({
                  ok: true,
                  data: {
                    message: t("profile:walletAddressBox.copiedToClipboard"),
                  },
                })
              }
            >
              <Button variant="default">{t("common:actions.copy")}</Button>
            </CopyToClipboard>
          </div>
        </div>
      </MidBox>
    </motion.div>
  );
};

export default WalletAddressBox;
